import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA3Tnb_V6FuLWvmmXNJIt5bITY53TdMyrc",
  authDomain: "coordiph-2.firebaseapp.com",
  databaseURL: "https://coordiph-2-default-rtdb.firebaseio.com",
  projectId: "coordiph-2",
  storageBucket: "coordiph-2.appspot.com",
  messagingSenderId: "144094694604",
  appId: "1:144094694604:web:47cfc726639d99748d4669",
  measurementId: "G-SQ4YD9V86N"
};

const app = initializeApp(firebaseConfig);
export const auth    = getAuth(app);
export const db      = getDatabase(app);
export const storage = getStorage(app);

const appSecundaria = initializeApp(firebaseConfig, "secundaria");
export const authSecundaria = getAuth(appSecundaria);